export default function initPushConseil() {
    const $formPushConseil = document.querySelectorAll<HTMLElement>('.js-form-push-conseil');
    $formPushConseil.forEach($container => {
        new PushConseil($container);
    });
}

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const contact_url: any;

class PushConseil {
    $el: HTMLElement;
    $agencesSelect: HTMLSelectElement | null;
    $conseilChoiceRadio: NodeListOf<HTMLInputElement> | null | undefined;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$agencesSelect = this.$el.querySelector('select[name=select-ville]');
        this.$conseilChoiceRadio = this.$el.querySelectorAll('input[name=conseil_choice]');
        this.init();
    }

    init() {
        this.$el?.addEventListener('submit', (evt) => {
            evt.preventDefault();
            if (this.$agencesSelect?.value && this.$agencesSelect?.value !== 'ville') {
                window.open(this.$agencesSelect?.value, '_blank');
            }
            if (this.$conseilChoiceRadio) {
                this.$conseilChoiceRadio.forEach((radio: HTMLInputElement) => {
                    if (radio.checked) {
                        location.href = contact_url + ('' !== radio.value ? '?categorie-formation=' + radio.value : '');
                    }
                });
            }
        });
    }
}
